(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["doma-banner-arrows"] && !Shopify.designMode) return;
  try {
    (() => {
  function mount() {
    const template = document.getElementById('DomaBannerArrows');
    if (!template) return;
    document.querySelectorAll('ct-slide-show').forEach(slider => {
      if (slider.querySelector('.doma-banner-arrows') || slider.querySelectorAll('ct-slide-show-item').length < 2) return;
      const controls = template.content.cloneNode(true);
      controls.querySelectorAll('button').forEach(button => {
        button.addEventListener('click', event => {
          event.preventDefault();event.stopPropagation();
          if (!slider.isInitialized) return;
          if (button.dataset.direction === 'next') slider.nextSlide();
          else slider.previousSlide();
        });
      });
      slider.appendChild(controls);
    });
  }
  customElements.whenDefined('ct-slide-show').then(mount);
  document.addEventListener('shopify:section:load', mount);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doma-delivery-location"] && !Shopify.designMode) return;
  try {
    (() => {
  const bar = document.querySelector('.doma-delivery');
  if (!bar) return;
  const message = bar.querySelector('[data-delivery-message]');
  const key = 'doma_location_native_v5';
  const valid = city => typeof city === 'string' && city.trim().length > 1 && city.length <= 100;
  const statesBR = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];
  let chosen;
  function show(city, uf, source) {
    if (!valid(city)) return;
    const short = bar.querySelector('[data-delivery-short]');
    const label = source === 'cep' ? 'Entrega para' : 'Região estimada';
    const destination = `${city.trim()}${uf ? ' — '+uf : ''}`;
    const regional = bar.dataset.regionalCopy === 'true';
    const near = ['RS','SC','PR','SP','RJ','MG','ES','DF','GO','MT','MS'].includes(uf);
    const policy = statesBR.includes(uf) ? (near ? bar.dataset.near : bar.dataset.far) : '';
    const text = regional ? destination + (policy ? ' · ' + policy : '') : `${label}: ${destination}`;
    if (short) short.textContent = text;
    message.textContent = text;
  }
  function publish(location) {
    bar.dataset.city = location.city;
    bar.dataset.region = location.uf || "";
    bar.dataset.postal = /^\d{8}$/.test(location.cep || '') ? location.cep : '';
    bar.dataset.locationSource = location.source === 'cep' ? 'cep' : 'ip';
    document.dispatchEvent(new CustomEvent('doma:location', {detail: {city: bar.dataset.city, uf: bar.dataset.region, cep: bar.dataset.postal, source: bar.dataset.locationSource}}));
  }
  function save(city, cep, source, uf) {
    const location = {city, cep, source, uf, at:Date.now()};
    chosen = location;
    show(city, uf, source);
    try { sessionStorage.setItem(key, JSON.stringify(location)); } catch (_) {}
    publish(location);
  }
  async function lookup(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 4000);
    try {
      const response = await fetch(url, {signal:controller.signal,credentials:'omit',referrerPolicy:'no-referrer'});
      if (!response.ok) throw new Error('lookup');
      return await response.json();
    } finally { clearTimeout(timer); }
  }
  const editor = bar.querySelector('.doma-location-edit');
  editor?.querySelector('form').addEventListener('submit', async event => {
    event.preventDefault();
    const form = event.currentTarget;
    const cep = form.elements.cep.value.replace(/\D/g, '');
    const status = form.querySelector('[role="status"]');
    const button = form.querySelector('button');
    if (!/^\d{8}$/.test(cep) || button.disabled) return;
    button.disabled = true;
    status.textContent = 'Consultando…';
    try {
      const data = await lookup('https://viacep.com.br/ws/' + cep + '/json/');
      if (data.erro || !valid(data.localidade) || !statesBR.includes(data.uf)) throw new Error('cep');
      save(data.localidade, cep, 'cep', data.uf);
      status.textContent = '';
      editor.open = false;
      editor.querySelector('summary').focus();
    } catch (_) { status.textContent = 'Não foi possível consultar. Confira o CEP e tente novamente.'; }
    finally { button.disabled = false; }
  });
  let cached;
  try {cached=JSON.parse(sessionStorage.getItem(key));} catch (_) {}
  document.addEventListener('doma:destination', event => {
    const location = event.detail;
    if (location?.source === 'cep' && valid(location.city) && statesBR.includes(location.uf) && /^\d{8}$/.test(location.cep || '')) save(location.city, location.cep, 'cep', location.uf);
  });
  if (['ip','cep'].includes(cached?.source) && valid(cached?.city) && statesBR.includes(cached.uf) && Date.now() >= cached.at && Date.now() - cached.at < (cached.source === 'cep' ? 86400000 : 3600000) && (cached.source !== 'cep' || /^\d{8}$/.test(cached.cep || ''))) {chosen=cached;show(cached.city, cached.uf, cached.source);publish(cached);return;}
  if (bar.dataset.ip !== 'true') return;
  try {if(Date.now()-Number(sessionStorage.getItem(key+'_attempt')) < 300000) return;sessionStorage.setItem(key+'_attempt',String(Date.now()));} catch (_) {}
  lookup('https://get.geojs.io/v1/ip/geo.json').then(data => {
    const states = {"acre":"AC","alagoas":"AL","amapa":"AP","amazonas":"AM","bahia":"BA","ceara":"CE","distrito federal":"DF","federal district":"DF","espirito santo":"ES","goias":"GO","maranhao":"MA","mato grosso":"MT","mato grosso do sul":"MS","minas gerais":"MG","para":"PA","paraiba":"PB","parana":"PR","pernambuco":"PE","piaui":"PI","rio de janeiro":"RJ","rio grande do norte":"RN","rio grande do sul":"RS","rondonia":"RO","roraima":"RR","santa catarina":"SC","sao paulo":"SP","sergipe":"SE","tocantins":"TO"};
    const region = String(data.region || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
    data.region_code = states[region];
    if (!data.region_code) throw new Error('region');
    return data;
  }).catch(() => lookup('https://ipapi.co/json/')).then(data => {
    if (data.error || !data.region_code) throw new Error('lookup');
    return data;
  }).catch(() => lookup('https://ipwho.is/?fields=success,country_code,region_code,city,postal')).then(data => {
    const uf = String(data.region_code || '').replace(/^BR-/, '').toUpperCase();
    if (chosen?.source !== 'cep' && data.success !== false && data.country_code === 'BR' && valid(data.city) && statesBR.includes(uf)) save(data.city, String(data.postal || '').replace(/\D/g, ''), 'ip', uf);
  }).catch(() => {});
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doma-engraving-reminder"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click',function(event){
  const button=event.target.closest('[data-engraving-motion]');
  if(!button)return;
  const video=button.closest('[data-engraving-reminder]').querySelector('video');
  if(!video)return;
  if(video.paused)video.play().catch(()=>{});
  else video.pause();
});
['play','pause'].forEach(function(type){document.addEventListener(type,function(event){
  const video=event.target;
  if(!video.matches?.('.doma-engraving-reminder__media video'))return;
  const button=video.closest('[data-engraving-reminder]').querySelector('[data-engraving-motion]');
  if(!button)return;
  button.textContent=video.paused?'▶':'Ⅱ';
  button.setAttribute('aria-label',video.paused?button.dataset.playLabel:button.dataset.pauseLabel);
},true)});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doma-header-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('doma-header-search')) {
  customElements.define('doma-header-search', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.mic = this.querySelector('.doma-search-mic');
      if (!this.mic) return;
      this.panel = this.querySelector('.doma-voice-help');
      this.status = this.querySelector('[data-voice-status]');
      this.input = this.querySelector('[name="q"]');
      this.startButton = this.querySelector('[data-voice-start]');
      this.startButton.disabled = false;
      this.Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
      this.mic.hidden = false;
      this.onClick = (event) => {
        if (event.target.closest('.doma-search-mic')) {
          this.panel.hidden = !this.panel.hidden;
          this.mic.setAttribute('aria-expanded', String(!this.panel.hidden));
          if (this.panel.hidden) this.recognition?.abort();
          if (!this.Recognition) { this.status.textContent = this.dataset.unsupported; this.startButton.hidden = true; }
        }
        if (event.target.closest('[data-voice-close]')) this.closeVoice();
        if (event.target.closest('[data-voice-start]')) this.startVoice();
      };
      this.onKey = (event) => { if (event.key === 'Escape') this.closeVoice(); };
      this.addEventListener('click', this.onClick);
      this.addEventListener('keydown', this.onKey);
    }
    closeVoice() {
      this.recognition?.abort();
      this.active = false;
      this.startButton.disabled = false;
      this.panel.hidden = true;
      this.mic.setAttribute('aria-expanded', 'false');
      this.mic.focus();
    }
    startVoice() {
      if (!this.Recognition || this.active) return;
      try {
        const recognition = this.recognition = new this.Recognition();
        recognition.lang = document.documentElement.lang || 'pt-BR';
        recognition.continuous = false;
        recognition.interimResults = false;
        recognition.onresult = (event) => {
          this.input.value = (event.results[0]?.[0]?.transcript || '').slice(0, 200);
          this.input.dispatchEvent(new Event('input', { bubbles: true }));
          this.status.textContent = this.dataset.ready;
          this.input.focus();
        };
        recognition.onerror = () => { this.status.textContent = this.dataset.error; };
        recognition.onend = () => { this.active = false; this.startButton.disabled = false; };
        this.active = true;
        this.startButton.disabled = true;
        this.status.textContent = this.dataset.listening;
        recognition.start();
      } catch {
        this.active = false;
        this.startButton.disabled = false;
        this.status.textContent = this.dataset.error;
      }
    }
    disconnectedCallback() {
      if (this.recognition) {
        this.recognition.onresult = this.recognition.onerror = this.recognition.onend = null;
        this.recognition.abort();
      }
      this.active = false;
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('keydown', this.onKey);
      this.bound = false;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doma-inline-search"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('doma-inline-search-panel')) {
  customElements.define('doma-inline-search-panel', class extends HTMLElement {
    connectedCallback() {
      this.onEscape = event => {
        if (event.key === 'Escape' && matchMedia('(min-width:990px)').matches) this.querySelector('input[type="search"]').blur();
      };
      this.addEventListener('keydown', this.onEscape);
    }
    disconnectedCallback() { this.removeEventListener('keydown', this.onEscape); }
  });
}
if (!customElements.get('doma-mobile-search-toggle')) {
  customElements.define('doma-mobile-search-toggle', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      const trigger = this.querySelector('a');
      const header = this.closest('#doma-compact-header');
      const panel = header.querySelector('.doma-inline-search');
      const input = panel.querySelector('input[type="search"]');
      const mobile = matchMedia('(max-width:989px)');
      const setOpen = (open, restoreFocus = false) => {
        header.classList.toggle('doma-mobile-search-open', open);
        trigger.setAttribute('aria-expanded', String(open));
        if (open) input.focus();
        else if (restoreFocus) trigger.focus();
      };
      trigger.addEventListener('click', event => {
        event.preventDefault();
        setOpen(trigger.getAttribute('aria-expanded') !== 'true');
      }, options);
      header.addEventListener('keydown', event => {
        if (event.key === 'Escape' && trigger.getAttribute('aria-expanded') === 'true') {
          event.preventDefault();
          setOpen(false, true);
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!panel.contains(event.target) && !this.contains(event.target)) setOpen(false);
      }, options);
      mobile.addEventListener('change', () => setOpen(false), options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doma-payment-info"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('doma-payment-info')) {
  customElements.define('doma-payment-info', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const dialog = this.querySelector('dialog');
      const trigger = this.querySelector('.doma-payment-link');
      if (!dialog || !trigger) return;
      trigger.addEventListener('click', () => { if (!dialog.open) { dialog.showModal(); dialog.scrollTop = 0; } });
      this.querySelector('.doma-payment-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        const bounds = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
      });
      dialog.addEventListener('close', () => trigger.focus({ preventScroll: true }));
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["doma-shipping-quote"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('doma-shipping-quote')) {
    customElements.define('doma-shipping-quote', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.events = new AbortController();
        this.generation = 0;
        this.output = this.querySelector('.doma-shipping__result');
        this.messages = this.querySelector('[data-messages]').dataset;
        this.addressGeneration = 0;
        this.cepForm = this.querySelector('.doma-shipping__form');
        this.freeBanner = this.querySelector('.doma-shipping__free-banner');
        this.freeStateEl = this.freeBanner.querySelector('[data-free-state]');
        this.freeStates = (this.dataset.freeStates || '').split(',').map(s => s.trim().toUpperCase()).filter(Boolean);
        this.root = this.closest('product-info') || this.closest('section');
        this.locationChanged = () => {
          if(this.editingCep) return;
          const bar = document.querySelector('.doma-delivery');
          const confirmed = bar?.dataset.locationSource === 'cep';
          this.cep = confirmed ? bar?.dataset.postal || '' : '';
          this.city = bar?.dataset.city || '';
          this.uf = bar?.dataset.region || '';
          this.source = confirmed ? 'cep' : 'ip';
          this.updateFreeBanner();
          this.schedule();
        };
        document.addEventListener('doma:location', this.locationChanged, {signal:this.events.signal});
        this.root?.addEventListener('change', event => {
          if (['id', 'quantity'].includes(event.target.name) || event.target.closest('variant-selects, variant-radios')) this.schedule();
        }, {signal:this.events.signal});
        this.observer = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) { this.visible = true; this.observer.disconnect(); this.schedule(); }
        }, {rootMargin:'100px'});
        this.observer.observe(this);
        this.locationChanged();

        // Pré-preenche o campo se já tiver CEP confirmado em sessão
        if (/^\d{8}$/.test(this.cep)) {
          this.cepForm.elements.cep.value = this.cep.replace(/^(\d{5})(\d{3})$/,'$1-$2');
        }

        this.cepForm?.addEventListener('submit',event=>{event.preventDefault();event.stopPropagation();this.chooseCep();},{signal:this.events.signal});
        this.cepForm?.addEventListener('input',()=>{
          this.editingCep=true;this.addressGeneration++;this.addressController?.abort();this.cep='';
          this.output.textContent='';
          this.clearPromise();
          this.updateFreeBanner();
          this.cepForm.querySelector('button').disabled=false;
        },{signal:this.events.signal});
        document.addEventListener('visibilitychange',()=>{if(!document.hidden&&this.visible&&this.cep)this.schedule();},{signal:this.events.signal});
      }
      disconnectedCallback() {
        this.generation++; this.controller?.abort(); this.events?.abort();
        this.addressGeneration++;this.addressController?.abort();
        this.observer?.disconnect(); clearTimeout(this.debounce); this.bound = false;
        clearInterval(this.promiseTimer); this.promiseTimer = null;
      }
      updateFreeBanner() {
        const hasResult = this.output.querySelector('.doma-shipping__rate') !== null;
        const eligible = this.uf && this.freeStates.includes(this.uf) && !hasResult;
        if (!eligible) { this.freeBanner.hidden = true; return; }
        const label = this.city ? (this.city + ' · ' + this.uf) : this.uf;
        this.freeStateEl.textContent = label;
        this.freeBanner.hidden = false;
      }
      async chooseCep(){
        const zip=this.cepForm.elements.cep.value.trim().replace('-','');
        if(!/^\d{8}$/.test(zip))return;
        this.editingCep=true;this.cep='';
        const revision=++this.addressGeneration,controller=new AbortController();
        this.addressController?.abort();this.addressController=controller;
        const button=this.cepForm.querySelector('button');button.disabled=true;this.output.textContent=this.messages.loading;
        const timer=setTimeout(()=>controller.abort(),8000);
        try{
          const response=await fetch('https://viacep.com.br/ws/'+zip+'/json/',{signal:controller.signal,credentials:'omit',referrerPolicy:'no-referrer'});
          if(!response.ok)throw new Error('cep');
          const address=await response.json();
          if(address.erro||String(address.cep||'').replace('-','')!==zip||typeof address.localidade!=='string'||!address.localidade.trim()||address.localidade.length>100||!['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'].includes(address.uf))throw new Error('cep');
          if(revision!==this.addressGeneration||controller.signal.aborted||!this.isConnected)return;
          const destination={cep:zip,city:address.localidade,uf:address.uf,source:'cep',at:Date.now()};
          try{sessionStorage.setItem('doma_location_native_v5',JSON.stringify(destination));}catch(_){}
          this.editingCep=false;this.cep=zip;this.city=destination.city;this.uf=destination.uf;this.source='cep';
          this.updateFreeBanner();
          document.dispatchEvent(new CustomEvent('doma:destination',{detail:destination}));
          this.schedule();
        }catch(_){if(revision===this.addressGeneration&&this.isConnected)this.output.textContent=this.messages.invalid;}
        finally{clearTimeout(timer);if(revision===this.addressGeneration)button.disabled=false;}
      }
      schedule() {
        this.generation++; this.controller?.abort(); clearTimeout(this.debounce);
        this.clearPromise();
        if (this.visible && /^\d{8}$/.test(this.cep)) this.debounce = setTimeout(() => this.calculate(), 450);
      }
      selection() {
        const form = document.getElementById(this.dataset.productForm);
        return {variantId:String(form?.querySelector('[name="id"]')?.value || ''), quantity:Number(form?.querySelector('[name="quantity"]')?.value || this.root?.querySelector('input[name="quantity"]')?.value || 1), cep:this.cep};
      }
      /* Contador regressivo em hora/min/seg — sem depender do módulo compartilhado */
      formatHMS(ms) {
        if (!Number.isFinite(ms) || ms <= 0) return '';
        let total = Math.floor(ms / 1000);
        const h = Math.floor(total / 3600);
        const m = Math.floor((total % 3600) / 60);
        const s = total % 60;
        if (h > 0) return h + 'h ' + m + 'min ' + s + 's';
        if (m > 0) return m + 'min ' + s + 's';
        return s + 's';
      }
      renderRates(result) {
        if (!Array.isArray(result.rates) || !result.rates.length || result.currency !== 'BRL') throw new Error('rates');
        const fragment = document.createDocumentFragment();
        for (const rate of result.rates) {
          if (!['PAC','SEDEX'].includes(rate.name?.toUpperCase()) || !Number.isSafeInteger(rate.priceCents) || rate.priceCents < 0 ||
              !Array.isArray(rate.days) || rate.days.length !== 2 || rate.days.some(day => !Number.isInteger(day) || day < 1 || day > 90) || rate.days[0] > rate.days[1]) throw new Error('rates');
          const row = document.createElement('div'); row.className = 'doma-shipping__rate';
          const name = document.createElement('span'); const price = document.createElement('strong');
          const days = rate.days[0] === rate.days[1] ? rate.days[1] : rate.days.join('–');
          const unit = rate.days[0] === 1 && rate.days[1] === 1 ? this.messages.days.replace('dias úteis','dia útil').replace('business days','business day') : this.messages.days;
          name.textContent = `${rate.name} · ${days} ${unit}`;
          price.textContent = rate.priceCents === 0 ? this.messages.free.toUpperCase() : new Intl.NumberFormat('pt-BR',{style:'currency',currency:'BRL'}).format(rate.priceCents/100);
          price.dataset.free=String(rate.priceCents===0);
          row.append(name,price); fragment.append(row);
        }
        this.output.replaceChildren(fragment);
        this.updateFreeBanner();
        this.renderPromise(result.rates);
      }
      clearPromise() {
        clearInterval(this.promiseTimer);this.promiseTimer=null;
        const box=this.querySelector('[data-shipping-promise]');
        box.hidden=true;box.removeAttribute('data-free');
        this.querySelector('[data-dispatch-note]').textContent='';
      }
      async promiseModule() {
        if(!this.promiseLoading)this.promiseLoading=import(this.dataset.promiseModule).catch(()=>null);
        return this.promiseLoading;
      }
      async renderPromise(rates) {
        const generation=this.generation,signature=JSON.stringify(this.selection());
        const lib=await this.promiseModule();
        if(!lib||!this.isConnected||generation!==this.generation||signature!==JSON.stringify(this.selection()))return;
        const rate=lib.pickHighlightRate(rates);if(!rate)return;
        const box=this.querySelector('[data-shipping-promise]');
        const noteEl=this.querySelector('[data-dispatch-note]');
        const stamp=date=>String(date.day).padStart(2,'0')+'/'+String(date.month).padStart(2,'0');
        const cutoff=Number(this.dataset.cutoffHour),collection=Number(this.dataset.collectionHour);
        const holidays=new Set((this.dataset.extraHolidays||'').split(/[\s,;]+/).filter(day=>/^\d{4}-\d{2}-\d{2}$/.test(day)));
        const clockSvg = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>';

        const paint=()=>{
          if(!this.isConnected||generation!==this.generation)return;
          const promise=lib.computeDeliveryPromise({now:new Date(),businessDaysMin:rate.days[0],businessDaysMax:rate.days[1],cutoffHour:Number.isInteger(cutoff)?cutoff:15,extraHolidays:holidays});
          if(!promise){this.clearPromise();return;}

          const dateStr = promise.exact
            ? promise.weekdayMax+', '+stamp(promise.arrivalMax)
            : stamp(promise.arrivalMin)+' a '+stamp(promise.arrivalMax);

          const greenTag = rate.priceCents===0
            ? '· <span class="doma-shipping__free-tag">'+rate.name.toUpperCase()+' '+this.messages.free.toUpperCase()+'</span>'
            : '· <span class="doma-shipping__green">'+rate.name.toUpperCase()+'</span>';

          box.querySelector('[data-promise-headline]').innerHTML =
            '<span class="doma-shipping__green">Chegará até</span> '+dateStr+' '+greenTag;

          // Contador em h/min/s — usa este.formatHMS (não depende do módulo compartilhado)
          const countdown = this.formatHMS(promise.msUntilCutoff);
          let dispatchText;
          if (promise.dispatchToday) {
            dispatchText = countdown
              ? this.messages.postingToday.replace('{time}', countdown)
              : this.messages.cutoffNow;
          } else {
            dispatchText = this.messages.postingNext.replace('{date}', stamp(promise.dispatch));
          }
          noteEl.innerHTML = clockSvg + '<span>' + dispatchText + '</span>';

          box.dataset.free=String(rate.priceCents===0);box.hidden=false;
        };
        paint();
        clearInterval(this.promiseTimer);
        this.promiseTimer=setInterval(paint,1000);
      }
      async calculate() {
        const input = this.selection(); const signature = JSON.stringify(input);
        if (!/^\d{8}$/.test(input.cep) || !/^\d{9,16}$/.test(input.variantId) || !Number.isInteger(input.quantity) || input.quantity < 1 || input.quantity > 10) return;
        const generation = ++this.generation;
        const controller = new AbortController(); this.controller = controller;
        const cacheKey = 'doma_quote_v1:' + signature;
        try {
          const cached = JSON.parse(sessionStorage.getItem(cacheKey) || 'null');
          if (cached && Date.now() - cached.at < 120000 && Date.now() >= cached.at) {this.renderRates(cached.result); return;}
          const cooldown = Number(sessionStorage.getItem('doma_quote_backoff'));
          if (cooldown > Date.now()) return;
        } catch (_) {}
        this.output.textContent = this.messages.loading;
        const timer = setTimeout(() => controller.abort(),30000);
        try {
          const response = await fetch('https://observant-bravery-production-79fd.up.railway.app/api/storefront/shipping',{method:'POST',mode:'cors',credentials:'omit',headers:{'Content-Type':'application/json'},body:signature,signal:controller.signal});
          const result = await response.json();
          if (!response.ok) {
            try {sessionStorage.setItem('doma_quote_backoff',String(Date.now()+60000));} catch (_) {}
            throw new Error('quote');
          }
          if (generation !== this.generation || signature !== JSON.stringify(this.selection()) || controller.signal.aborted) return;
          this.renderRates(result);
          try {sessionStorage.setItem(cacheKey,JSON.stringify({at:Date.now(),result}));} catch (_) {}
        } catch (_) {
          if (generation === this.generation && signature === JSON.stringify(this.selection())) {
            this.output.textContent = this.messages.error;
            this.clearPromise();
            this.updateFreeBanner();
          }
        } finally {clearTimeout(timer);}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
